import { render, staticRenderFns } from "./moreButton.vue?vue&type=template&id=25bcc934&scoped=true"
import script from "./moreButton.vue?vue&type=script&lang=js"
export * from "./moreButton.vue?vue&type=script&lang=js"
import style0 from "./moreButton.vue?vue&type=style&index=0&id=25bcc934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25bcc934",
  null
  
)

export default component.exports